(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.var.show.customer.show.project.bulkStateChange', {
      url: '/bulkStateChange',
      template: `<new-front-container path="'bulk-assets-config'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.BulkStateChange" | translate}}',
      },
    });
  }
})();
